import { createEvent, createStore, restore, sample } from 'effector'
import { persist } from 'effector-storage/local'
import {
  Currency,
  InProgress,
  Wallet,
  WalletResponse,
} from '../../../../views/widgets/walletCard/types'
import { fx } from '../../../../libs'
import { getCurrencies } from '../details/model'

export const setTableView = createEvent<boolean>()
export const $isTableView = createStore(false).on(
  setTableView,
  (_, view) => view,
)

persist({ store: $isTableView, key: 'wallets_view' })

export const walletsListMounted = createEvent()

export const allCurrenciesMounted = createEvent()

export const getWallets = fx<void, WalletResponse>({
  method: 'GET',
  url: `/finance/wallet`,
})

export const getInProgress = fx<void, InProgress>({
  method: 'GET',
  url: `/finance/transaction/total`,
})

export const $wallets = restore<Wallet[]>(
  getWallets.doneData.map((a) => a.body.items),
  [],
)
export const $inProcess = restore<InProgress>(
  getInProgress.doneData.map((a) => a.body),
  { localBalances: [] },
)

export const $allCurrencies = restore<Currency[]>(
  getCurrencies.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: walletsListMounted,
  fn: () => ({
    query: {
      populate: JSON.stringify(['Wallet', 'Wallet.paymentSystem']),
      order: 'name',
    },
  }),
  target: getWallets,
})

sample({
  // @ts-ignore
  clock: walletsListMounted,
  fn: () => {
    let query = {
      where: JSON.stringify({ inProgress: true }),
    }

    return {
      query,
    }
  },
  target: getInProgress,
})

sample({
  clock: allCurrenciesMounted,
  fn: () => {
    let query = {
      order: 'code',
    }
    return {
      query,
    }
  },
  target: getCurrencies,
})
